// Codekit -->
// @codekit-prepend "global/vars.js"
// @codekit-prepend "utilities/rhparallax.js"
// @codekit-prepend "utilities/loadIn.js"
// @codekit-prepend "utilities/debounce.js"
// @codekit-prepend "components/header.js"
// @codekit-prepend "components/inline-video.js"
// @codekit-prepend "components/accordion.js"

// @codekit-append "global/resize.js"



//call functions

//header
window.addEventListener("scroll", debounce(headerReveal));


//accordion
if(typeof(accordion) != 'undefined' && accordion != null){
    unoAccordion();
}


//on ready
$(document).ready(function () {
    
    $body.rhLoadIn();

    $(".parallax").rhParallax({
        parallaxRatio: 1.4
    });

    //images loaded
    $(".bgImgLoad").imagesLoaded({ background: ".bgImgLoad" }, function () {
        $(".bgImgLoad").animate({ opacity: "1" }, 300);
    });

    $(".imgLoad").imagesLoaded(function () {
        $(".imgLoad").animate({ opacity: "1" }, 300);
    });


    const heroHowButton = document.querySelector('.js-how-it-works-btn');
    const howSection = document.getElementById('how-it-works');
    const scrollToPos = howSection.offsetTop;

    heroHowButton.addEventListener("click", (e) => {
        e.preventDefault();
        $(window).scrollTo( scrollToPos, 300, { axis: 'y'});

    })


}); // end doc ready

//This pauses videos on page refresh
//Ensures no flash of white
$(window).on("beforeunload", function () {
    //console.log('PAUSE VIDEO');
    $(".vidUnload").each(function () {
        $(this).get(0).pause();
    });
});